import { render, staticRenderFns } from "./ReturnPlayer.vue?vue&type=template&id=80bf4890&scoped=true&"
import script from "./ReturnPlayer.vue?vue&type=script&lang=js&"
export * from "./ReturnPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf4890",
  null
  
)

export default component.exports